var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('audio',{ref:"track",attrs:{"autoplay":_vm.playing,"src":_vm.audio.url},on:{"timeupdate":_vm.onTimeUpdate,"ended":_vm.emitEnded,"error":_vm.emitError}})])}
var staticRenderFns = []

export { render, staticRenderFns }